'use client';

import { ComboboxSelect } from '@zealot/ui/components/combobox-select';
import { SimpleSelect } from '@zealot/ui/components/simple-select';

// gloss
export const SEARCHABLE_THRESHOLD = 16;

const VOCAB_ITEM_TEXT = 'line-clamp-3 min-w-0 max-w-[360px] flex-1 whitespace-normal break-words';

type VocabularySelectProps = {
  items: { value: string; label: string; disabled?: boolean; group?: string }[];
  value: string | null;
  onValueChange: (next: string | null) => void;
  placeholder: string;
  'aria-label': string;
  size?: 'sm' | 'default' | 'lg';
  showClear?: boolean;
  disabled?: boolean;
  className?: string;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

// gloss
export const VocabularySelect = ({
  items,
  value,
  onValueChange,
  placeholder,
  size = 'default',
  showClear = false,
  disabled,
  className,
  defaultOpen,
  onOpenChange,
  'aria-label': ariaLabel,
}: VocabularySelectProps) =>
  items.length > SEARCHABLE_THRESHOLD || defaultOpen || showClear ? (
    <ComboboxSelect
      aria-label={ariaLabel}
      items={items}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      trigger="button"
      showClear={showClear}
      disabled={disabled}
      size={size}
      className={className}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      popupClassName="w-auto max-w-[420px]"
      itemTextClassName={VOCAB_ITEM_TEXT}
    />
  ) : (
    <SimpleSelect
      aria-label={ariaLabel}
      items={items}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      className={className}
      itemTextClassName={VOCAB_ITEM_TEXT}
    />
  );

export type { VocabularySelectProps };
